import React from 'react';
import { Size } from '../../Enums/Size.enum';
import { useTreatmentContext } from '../../Services/TreatmentContext';
import Modal from '../Modal/Modal';
// @ts-ignore
import styles from './ConfirmCreateCaseModal.module.scss';
import useTranslation from '../../Hooks/useTranslation';
import Button from '../Button/Button';
import { Theme } from '../../Enums/Theme.enum';
import {
	acceptCase,
	connectWithPatient,
	showCaseDetail,
} from '../../Modules/Case/Services/case.service';
import LinkButton from '../Button/LinkButton';
import { useAppContext } from '../../Services/AppContext';

interface ConfirmCreateCaseModalProps {
	isOpen: boolean;
	cases: { id: string; name: string }[];
	patientName: string;
	onClose: () => void;
	onCaseClick?: (caseId: string) => void;
	patientId: string;
}
const ConfirmCreateCaseModal: React.FC<ConfirmCreateCaseModalProps> = ({
	onClose,
	patientName,
	isOpen,
	cases,
	onCaseClick,
	patientId,
}) => {
	const { isCase } = useTreatmentContext();
	const { t } = useTranslation();
	const { userData, workplaceId } = useAppContext();
	const hasManyCases = cases.length > 1;

	const handleCreateNewCase = async () => {
		await connectWithPatient(userData.id, patientId, workplaceId);
	};

	const handleOpenExistingCase = async (caseId: string) => {
		await acceptCase(caseId, userData.id, false);
		onCaseClick?.(caseId);
		onClose();
	};

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.MD}>
			<Modal.Header title={'component.modalBeforeCreateNewCase.title'} />
			<Modal.Content contentScroll>
				<div className={styles.wrapper}>
					<p>
						{t(
							hasManyCases
								? 'component.modalBeforeCreateNewCase.descriptionTextMany'
								: 'component.modalBeforeCreateNewCase.descriptionTextOne',
							{ pacientFullName: patientName ?? '' },
						) + ':'}
					</p>
					<ul>
						{cases.map(item => (
							<li key={item.id}>
								<LinkButton
									theme={Theme.BLUE}
									onClick={() => handleOpenExistingCase(item.id)}
									title={item.name}
									key={item.id}
								/>
							</li>
						))}
					</ul>
					<p>{t('component.modalBeforeCreateNewCase.footerText')}</p>
					<div className={styles.footer}>
						<Button
							onClick={handleCreateNewCase}
							title={'component.modalBeforeCreateNewCase.createNewCase'}
							theme={Theme.GREEN}
						/>
					</div>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default ConfirmCreateCaseModal;
